import { Box } from '@mui/material';

const IndicatorsPage2 = () => {
  return (
    <>
      <Box height={'100%'} width={'100%'} p={'20px'}>
        <iframe
          title="Portafolio Indicadores Limpieza de col v2"
          width="100%"
          height="100%"
          src="https://app.powerbi.com/view?r=eyJrIjoiMTk2N2YyMjAtYTU2My00MzE0LTgzNmMtMDYzMmNiMTI0M2E5IiwidCI6IjRjMDdiMDA3LTU3N2UtNDY1Ny1hNjUyLWYyNTBkNzc4OTBjMyJ9&pageName=ReportSection853f11ce089e401594bd"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </Box>
    </>
  );
};

export default IndicatorsPage2;
